import Action from '../../Action'
// import './styles/ModalDeleteBuzon.css'
import { useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalDeleteBuzon =({languaje,handleShowPopup,buscar_cis,mode,Buzon,auth,closDeleteBuzonModal,setRegisterIsValid,setData,setLoading,setError,server})=>{
    const [loadingM,setLoadingM]=useState(false);
    const [validaBtn, setValidaBtn] = useState(true);
    const [textAreaValue, setTextAreaValue] = useState('');
   
    const handleTextAreaChange = (event) => {
        if(event.target.value.length <4){
            setValidaBtn(true)
        }else{
            setValidaBtn(false)
        }
        
        setTextAreaValue(event.target.value);
      };
    const authorize=()=>{
        const data={
            // action: auth,
            comment: textAreaValue
        }
        setLoading(true)
        setRegisterIsValid(true)
        const fetchDataPost = async () => {

          let url=server.url+'/api/v1/cassia/cis_v2/folios/'+Buzon.id+'/'+auth
          let acction=''
          if(auth==='approve'){
              acction='requests/'+Buzon.id+'/apply'
          }
          if(auth==='reject'){
              acction='requests/'+Buzon.id+'/cancel'
          }
          if(auth==='request_info'){
              acction=''+Buzon.id+'/add_info'
          }
       try {
           const response = await fetch(url, {
             method: 'POST',  
             headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
             body:JSON.stringify(data)
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             setRegisterIsValid(false)
             // Manejo de la respuesta
             setData(data1)
             buscar_cis()
             closDeleteBuzonModal()
             handleShowPopup('Completado',data1.message,'',true)
             // console.log(data1);
           } else {
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
            // Manejo de errores
            setError(error)
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const statusWF={
  'apply_changes':'var(--second-color)',
  'start_process':'var(--green)',
  'cancel':'var(--red-alert)',
}
const txtWF={
  'apply_changes':'APLICAR CAMBIOS',
  'start_process':'COMENZAR PROCESO',
  'cancel':'CANCELAR PROCESO',
}
 const reqField=()=>{
    return(
      <p className='reqField-gs'>
        *
      </p>
    )
  }
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs auth-modal-gs'>
                            <div className={'head-card-modal-gs' } >
                                <div className={'title-head-card-modal-gs '} style={{color:statusWF[auth]}}  >
                                   {txtWF[auth]}
                                </div>
                            </div>
                            <div className='content-card-modal-gs'>
                                <div className='cont-info-modal-delete-gs'>
                                    <div className='cont-message-modal-delete-gs' style={{height:'50%'}}>
                                    <div className='txt-user-modal-delete-buzon-gs' style={{display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
                                                {auth=='start_process'?
<div style={{color:'var(--txt-color)',textAlign:'center'}} >{'Marca un folio como En Proceso. Esto es un paso manual para que el usuario indique que va a empezar a trabajar en la aplicación del cambio.'}</div>
:(auth=='apply_changes')?
<div className="cont-msg-alert-confirm-action">
                            <div className="compact-msg-alert-confirm-action">
                                <img  className='icon-msg-alert' src={"/iconos/warning.png"}alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                                <div className="msg-alert-txt-confirm-action">

                                    {'--- ¡ACCIÓN CRÍTICA! --- Toma un folio (en PENDING o IN_PROCESS), ejecuta las tareas externas (Zabbix, Inventory) si es necesario, actualiza los CIs principales con los datos del detail, y marca todo como FINALIZED.'}
                                </div>
                            </div>
                            
                        </div>:
                                                <div style={{color:'var(--txt-color)',textAlign:'center'}} >{'Cancela un folio que esté en PENDING o IN_PROCESS. REGLA: No se puede cancelar un folio en PENDING_AUTHORIZATION. Esto desbloquea los CIs y cancela los details y la solicitud de auth.'}</div>

                                                }
                                            </div>
                                     
                                    </div>
                                    
                                    <div className='cont-btn-modal-delete'>
                                            {
                                                (loadingM)?<LoadSimple></LoadSimple>:
                                                <>
                                                <Action  disabled={false} origen={(auth)?'Green':'Red'} titulo={(auth)?capitalizeFirstLetter(lang[languaje]['aceptar']):capitalizeFirstLetter(lang[languaje]['rechazar'])}  action={authorize}></Action>
                                            <Action  disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closDeleteBuzonModal}></Action>
                                                </>
                                            }
                                    </div>
                                </div>
                            </div>
            </div>
        </div>
    )
}

export default ModalDeleteBuzon